import { render, staticRenderFns } from "./d-swiper.vue?vue&type=template&id=0d5c6f74&"
import script from "./d-swiper.vue?vue&type=script&lang=js&"
export * from "./d-swiper.vue?vue&type=script&lang=js&"
import style0 from "./d-swiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports